module.exports = __webpack_public_path__ + "static/img/total.7df2371c.gif";